import React from "react";
import { Carousel } from "react-bootstrap";

import Jumbotron from "../Jumbotron";
import "./style.css";

const books = [
  {
    name: "7habbits",
    src: "./books/7habbits.jpg",
  },
  {
    name: "theOneThing",
    src: "./books/theOneThing.jpg",
  },
  {
    name: "elonMusk",
    src: "./books/elonMusk.jpg",
  },
  {
    name: "atomicHabbit",
    src: "./books/atomicHabbit.jpg",
  },
  {
    name: "100$startup",
    src: "./books/100$startup.jpg",
  },
  {
    name: "deepWork",
    src: "./books/deepWork.jpg",
  },
  {
    name: "monk",
    src: "./books/monk.jpg",
  },
  {
    name: "richDadPoorDad",
    src: "./books/richDadPoorDad.jpg",
  },
  {
    name: "rework",
    src: "./books/rework.jpg",
  },
];

const BootStrapCustomCarousel: React.FC = () => (
  <Jumbotron margin="10px auto" padding="100px" width="350px" justifyContent="center">
    <Carousel indicators>
      {books &&
        books.map((book) => (
          <Carousel.Item key={book.name}>
              <img width="auto" height="500px" className="d-block" src={book.src} alt={book.name} />
          </Carousel.Item>
        ))}
    </Carousel>
  </Jumbotron>
);

export default BootStrapCustomCarousel;
